import * as action from './NotificationAction'
import { default as actionType } from './NotificationActionType'
import { default as reducer } from './NotificationReducer'

export const NOTIFICATION = {
  action,
  actionType,
  reducer
}

export default action
